// --- plan limits ---
export type Plan = "free" | "pro" | "business"

// what each plan can do
export const LIMITS = {
  free: {
    workspaces: 1,
    members: 3,
    projects: 3,
    boards: Infinity,
    cards: Infinity,
    attachments: false,
    auditLog: false,
    boardColors: true,
    customColors: false,
    timeline: false,
  },
  pro: {
    workspaces: Infinity,
    members: 10,
    projects: Infinity,
    boards: Infinity,
    cards: Infinity,
    attachments: true,
    auditLog: true,
    boardColors: true,
    customColors: true,
    timeline: true,
  },
  business: {
    workspaces: Infinity,
    members: Infinity,
    projects: Infinity,
    boards: Infinity,
    cards: Infinity,
    attachments: true,
    auditLog: true,
    boardColors: true,
    customColors: true,
    timeline: true,
  },
} as const satisfies Record<Plan, {
  workspaces: number
  members: number
  projects: number
  boards: number
  cards: number
  attachments: boolean
  auditLog: boolean
  boardColors: boolean
  customColors: boolean
  timeline: boolean
}>

// coerce a string into a Plan, default to free
export function getPlan(plan: string | null | undefined): Plan {
  if (plan === "pro") return "pro"
  if (plan === "business") return "business"
  return "free"
}

type NumericKey = "workspaces" | "members" | "projects" | "boards" | "cards"
type BoolKey = "attachments" | "auditLog" | "boardColors" | "customColors" | "timeline"

// get a numeric limit for a plan (workspaces, members, etc)
export function numericLimit(plan: string | null | undefined, key: NumericKey): number {
  return LIMITS[getPlan(plan)][key] as number
}

// get a boolean limit for a plan (attachments, auditLog, etc)
export function boolLimit(plan: string | null | undefined, key: BoolKey): boolean {
  return LIMITS[getPlan(plan)][key] as boolean
}
